<template>
  <div class="dialog_container">
    <el-dialog
      title="车辆维修记录（检测完成）详情"
      :visible="dialogShow"
      width="837px"
      @close="dialogClose"
      top="10vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <div class="form_title">基本信息</div>
        <ul class="info_box">
          <li>
            <div class="li_title">车牌号码：</div>
            <div class="li_text">{{ dialogData.carNumber }}</div>
          </li>
          <li>
            <div class="li_title">车牌颜色：</div>
            <div class="li_text">{{ dialogData.carColorStr }}</div>
          </li>
          <li>
            <div class="li_title">车辆类型：</div>
            <div class="li_text">{{ dialogData.carColorStr }}</div>
          </li>
          <li>
            <div class="li_title">厂牌型号：</div>
            <div class="li_text">{{ dialogData.carModel }}</div>
          </li>
          <li>
            <div class="li_title">车辆营运性质：</div>
            <div class="li_text">{{ dialogData.carServiceStr }}</div>
          </li>
          <li>
            <div class="li_title">车主单位：</div>
            <div class="li_text">{{ dialogData.companyUserName }}</div>
          </li>
          <li>
            <div class="li_title">维修状态：</div>
            <div class="li_text">{{ dialogData.repairStateStr }}</div>
          </li>
        </ul>

        <div class="form_title">维修信息</div>
        <ul class="info_box">
          <li>
            <div class="li_title">维修企业：</div>
            <div class="li_text">{{ dialogData.repairCompanyName }}</div>
          </li>
          <li>
            <div class="li_title">进厂时间：</div>
            <div class="li_text">{{ dialogData.factoryTime }}</div>
          </li>
          <li>
            <div class="li_title">进厂里程数：</div>
            <div class="li_text">{{ dialogData.factoryMile }}</div>
          </li>
          <li>
            <div class="li_title">提交送检时间：</div>
            <div class="li_text">{{ dialogData.inspectTime }}</div>
          </li>
          <li>
            <div class="li_title">工位：</div>
            <div class="li_text">{{ dialogData.station }}</div>
          </li>
          <li>
            <div class="li_title">主修人员：</div>
            <div class="li_text">{{ dialogData.repairPerson }}</div>
          </li>
          <li>
            <div class="li_title">维修开始时间：</div>
            <div class="li_text">{{ dialogData.inspectStartTime }}</div>
          </li>
          <li>
            <div class="li_title">维修开始结束：</div>
            <div class="li_text">{{ dialogData.inspectEndTime }}</div>
          </li>
          <li>
            <div class="li_title">技术负责人：</div>
            <div class="li_text">{{ dialogData.technologyPerson }}</div>
          </li>
          <li>
            <div class="li_title">辅修人员：</div>
            <div class="li_text">{{ dialogData.minorPerson }}</div>
          </li>
          <li>
            <div class="li_title">下次维修时间：</div>
            <div class="li_text">{{ dialogData.nextRepairTime }}</div>
          </li>
          <li>
            <div class="li_title">下次维修里程：</div>
            <div class="li_text">{{ dialogData.nextRepairMile }}</div>
          </li>
          <li>
            <div class="li_title">质检员：</div>
            <div class="li_text">{{ dialogData.qualityPerson }}</div>
          </li>
        </ul>

        <div class="form_title">附件</div>
        <div class="uploading_box">
          <div class="certificate">
            <div class="upload_img_box">
              <div class="card_title">进厂图片</div>
              <div v-if="dialogData.factoryImage" class="onebox">
                <div
                  class="twobox"
                  v-if="dialogData.factoryImage.indexOf('.pdf') != -1"
                >
                  <el-image
                    class="avatar_img_pd"
                    src="../../../../static/images/pdf_icon.png"
                  ></el-image>
                </div>
                <el-image
                  v-else
                  :src="imgHttp + dialogData.factoryImage"
                  class="avatar_img"
                />
              </div>
              <div class="onebox" v-else>
                <div class="twobox">
                  <img
                    class="avatar_img_pd"
                    src="../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="btns_box">
                <el-button
                  class="img_btn"
                  v-if="
                    dialogData.factoryImage &&
                    dialogData.factoryImage.indexOf('.pdf') != -1
                  "
                >
                  <a
                    class="img_a"
                    :href="imgHttp + dialogData.factoryImage"
                    target="_blank"
                    rel="noopener noreferrer"
                    >预览</a
                  >
                </el-button>
                <el-button
                  v-else
                  class="img_btn"
                  :disabled="!dialogData.factoryImage ? true : false"
                  @click="handlePictureCardPreview(1)"
                  >预览</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="
                    !dialogData.factoryImage ||
                    dialogData.factoryImage.indexOf('.pdf') != -1
                      ? true
                      : false
                  "
                  @click="downs(1)"
                  >下载</el-button
                >
              </div>
            </div>
          </div>
          <div class="certificate">
            <div class="upload_img_box">
              <div class="card_title">送检图片</div>
              <div v-if="dialogData.inspectImage" class="onebox">
                <div
                  class="twobox"
                  v-if="dialogData.inspectImage.indexOf('.pdf') != -1"
                >
                  <el-image
                    class="avatar_img_pd"
                    src="../../../../static/images/pdf_icon.png"
                  ></el-image>
                </div>
                <el-image
                  v-else
                  :src="imgHttp + dialogData.inspectImage"
                  class="avatar_img"
                />
              </div>
              <div class="onebox" v-else>
                <div class="twobox">
                  <img
                    class="avatar_img_pd"
                    src="../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="btns_box">
                <el-button
                  class="img_btn"
                  v-if="
                    dialogData.inspectImage &&
                    dialogData.inspectImage.indexOf('.pdf') != -1
                  "
                >
                  <a
                    class="img_a"
                    :href="imgHttp + dialogData.inspectImage"
                    target="_blank"
                    rel="noopener noreferrer"
                    >预览</a
                  >
                </el-button>
                <el-button
                  v-else
                  class="img_btn"
                  :disabled="!dialogData.inspectImage ? true : false"
                  @click="handlePictureCardPreview(2)"
                  >预览</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="
                    !dialogData.inspectImage ||
                    dialogData.inspectImage.indexOf('.pdf') != -1
                      ? true
                      : false
                  "
                  @click="downs(2)"
                  >下载</el-button
                >
              </div>
            </div>
          </div>
          <div class="certificate">
            <div class="upload_img_box">
              <div class="card_title">维修结束图片</div>
              <div v-if="dialogData.repairImage3" class="onebox">
                <div
                  class="twobox"
                  v-if="dialogData.repairImage3.indexOf('.pdf') != -1"
                >
                  <el-image
                    class="avatar_img_pd"
                    src="../../../../static/images/pdf_icon.png"
                  ></el-image>
                </div>
                <el-image
                  v-else
                  :src="imgHttp + dialogData.repairImage3"
                  class="avatar_img"
                />
              </div>
              <div class="onebox" v-else>
                <div class="twobox">
                  <img
                    class="avatar_img_pd"
                    src="../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="btns_box">
                <el-button
                  class="img_btn"
                  v-if="
                    dialogData.repairImage3 &&
                    dialogData.repairImage3.indexOf('.pdf') != -1
                  "
                >
                  <a
                    class="img_a"
                    :href="imgHttp + dialogData.repairImage3"
                    target="_blank"
                    rel="noopener noreferrer"
                    >预览</a
                  >
                </el-button>
                <el-button
                  v-else
                  class="img_btn"
                  :disabled="!dialogData.repairImage3 ? true : false"
                  @click="handlePictureCardPreview(1)"
                  >预览</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="
                    !dialogData.repairImage3 ||
                    dialogData.repairImage3.indexOf('.pdf') != -1
                      ? true
                      : false
                  "
                  @click="downs(1)"
                  >下载</el-button
                >
              </div>
            </div>
          </div>
          <div class="certificate">
            <div class="upload_img_box">
              <div class="card_title">结算清单</div>
              <div v-if="dialogData.repairCost" class="onebox">
                <div
                  class="twobox"
                  v-if="dialogData.repairCost.indexOf('.pdf') != -1"
                >
                  <el-image
                    class="avatar_img_pd"
                    src="../../../../static/images/pdf_icon.png"
                  ></el-image>
                </div>
                <el-image
                  v-else
                  :src="imgHttp + dialogData.repairCost"
                  class="avatar_img"
                />
              </div>
              <div class="onebox" v-else>
                <div class="twobox">
                  <img
                    class="avatar_img_pd"
                    src="../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="btns_box">
                <el-button
                  class="img_btn"
                  v-if="
                    dialogData.repairCost &&
                    dialogData.repairCost.indexOf('.pdf') != -1
                  "
                >
                  <a
                    class="img_a"
                    :href="imgHttp + dialogData.repairCost"
                    target="_blank"
                    rel="noopener noreferrer"
                    >预览</a
                  >
                </el-button>
                <el-button
                  v-else
                  class="img_btn"
                  :disabled="!dialogData.repairCost ? true : false"
                  @click="handlePictureCardPreview(4)"
                  >预览</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="
                    !dialogData.repairCost ||
                    dialogData.repairCost.indexOf('.pdf') != -1
                      ? true
                      : false
                  "
                  @click="downs(4)"
                  >下载</el-button
                >
              </div>
            </div>
          </div>
          <div class="certificate">
            <div class="upload_img_box">
              <div class="card_title">合格证</div>
              <div v-if="dialogData.repairCertImage" class="onebox">
                <div
                  class="twobox"
                  v-if="dialogData.repairCertImage.indexOf('.pdf') != -1"
                >
                  <el-image
                    class="avatar_img_pd"
                    src="../../../../static/images/pdf_icon.png"
                  ></el-image>
                </div>
                <el-image
                  v-else
                  :src="imgHttp + dialogData.repairCertImage"
                  class="avatar_img"
                />
              </div>
              <div class="onebox" v-else>
                <div class="twobox">
                  <img
                    class="avatar_img_pd"
                    src="../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="btns_box">
                <el-button
                  class="img_btn"
                  v-if="
                    dialogData.repairCertImage &&
                    dialogData.repairCertImage.indexOf('.pdf') != -1
                  "
                >
                  <a
                    class="img_a"
                    :href="imgHttp + dialogData.repairCertImage"
                    target="_blank"
                    rel="noopener noreferrer"
                    >预览</a
                  >
                </el-button>
                <el-button
                  v-else
                  class="img_btn"
                  :disabled="!dialogData.repairCertImage ? true : false"
                  @click="handlePictureCardPreview(5)"
                  >预览</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="
                    !dialogData.repairCertImage ||
                    dialogData.repairCertImage.indexOf('.pdf') != -1
                      ? true
                      : false
                  "
                  @click="downs(5)"
                  >下载</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn btn_ok" @click="confirm">确 认</el-button>
      </span>
    </el-dialog>
    <preview-image
      :show.sync="dialogVisible"
      :name="dialogImageName"
      :url="dialogImageUrl"
    />
  </div>
</template>

<script>
import config from "@/utils/config";
import previewImage from "@/components/previewImage.vue";
import { downloadFile } from "@/utils/util";
export default {
  name: "",
  data() {
    return {
      textarea: "",
      addForm: {},
      receiveList: [],
      imgHttp: "",
      dialogImageUrl: "",
      dialogImageName: "",
      dialogVisible: false
    };
  },
  components: {
    previewImage
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default: {},
    },
  },
  created() {
    this.imgHttp = config.baseUrl;
  },
  methods: {
    confirm() {
      this.$emit("update:dialogShow", false);
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
    handlePictureCardPreview(index) {
      let url = "";
      let name = "";
      if (index === 1) {
        url = this.dialogData.factoryImage;
        name = "进厂图片";
      } else if (index === 2) {
        url = this.dialogData.inspectImage;
        name = "送检图片";
      }
      this.dialogImageUrl = this.imgHttp + url;
      this.dialogImageName = name;
      this.dialogVisible = true;
    },
    downs(index) {
      let url = "";
      let name = "";
      if (index === 1) {
        url = this.dialogData.factoryImage;
        name = "进厂图片";
      } else if (index === 2) {
        url = this.dialogData.inspectImage;
        name = "送检图片";
      }
      downloadFile(this.imgHttp + url, name);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
.uploading_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .certificate {
    width: 360px;
    height: 270px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    margin-bottom: 3px;
    display: flex;
    flex-wrap: wrap;
  }
  .certificate:nth-child(n + 3) {
    margin-top: 30px;
  }
}
.info_box {
  > li {
    width: 390px !important;
  }
  .li_3 {
    justify-content: flex-start;
    > div {
      display: flex;
      margin-right: 15px;
    }
    .chenghao {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/maintainRecord_component/detail_3.vue